import { memo } from 'react';
import { AdpMassFlowMeterChart } from './AdpMassFlowMeterChart/AdpMassFlowMeterChart';
import { IProfileData } from '../../types/api/profile';
import { isEmpty } from 'lodash';
import NoDataDisplay from '../NoDataDisplay/NoDataDisplay';
import { Box } from '@mui/material';

export const AdpMassFlowMeterLC = memo<{
  values?: IProfileData[];
  loading: boolean;
  isEmerson: boolean;
}>((props) => {
  return (
    <Box minHeight={392}>
      {!props.loading && isEmpty(props.values) ? (
        <NoDataDisplay />
      ) : (
        <AdpMassFlowMeterChart
          isEmerson={props.isEmerson}
          loading={props.loading}
          values={props.values as IProfileData[]}
          height="392px"
        />
      )}
    </Box>
  );
});

export default AdpMassFlowMeterLC;
